import { createCustomEnum } from "./customEnum";

const OwnerTypes = createCustomEnum({
	owner1: {
		name: "owner1",
		value: 1,
		displayName: "Owner 1",
	},
	owner2: {
		name: "owner2",
		value: 2,
		displayName: "Owner 2",
	},
	owner3: {
		name: "owner3",
		value: 3,
		displayName: "Owner 3",
	},
	owner4: {
		name: "owner4",
		value: 4,
		displayName: "Owner 4",
	},
	authorized_signer: {
		name: "authorized_signer",
		value: 5,
		displayName: "Authorized Signer",
	},
});

export default OwnerTypes;
